import type {ChannelSessionDetail} from '../types/network';

export type PlayerInfoDetail = {
  channel_session_code: string;
  user_code: string;
  user_role: string | null;

  icon: string | null;
  avatar: null;
  name: string | null;
  user_type: string;
};

export const createCHeliPlayerInfoFromChannelSessionDetail = (
  channelSession: ChannelSessionDetail
): CHeliPlayerInfo => {
  return new CHeliPlayerInfo({
    channel_session_code: channelSession.channel_session_code,
    user_code: channelSession.user_code,
    user_role: channelSession.user_role,
    icon: null, // stub
    avatar: null, // stub
    name: null, // stub
    user_type: channelSession.user_type
  });
};

export class CHeliPlayerInfo {
  m_playerInfo: PlayerInfoDetail | null;
  constructor(playerInfo: PlayerInfoDetail) {
    this.m_playerInfo = playerInfo;
  }
  getValue(key: keyof PlayerInfoDetail) {
    if (this.m_playerInfo) {
      return this.m_playerInfo[key];
    }
    return undefined;
  }

  getUserId() {
    return this.m_playerInfo?.user_code || '';
  }

  getChannelSessionCode() {
    return this.m_playerInfo?.channel_session_code || '';
  }
  getRole() {
    if (!this.m_playerInfo?.user_role) {
      return 'normal';
    }
    return this.m_playerInfo?.user_role || '';
  }
}
